import {computed, signal} from "@preact/signals-react";
import {IEventV2} from "@/app/dashboard/models/Event";
import {getSingleEventList} from "@/services/events-service";
import {getPath} from "@/lib/utils";
import {loadSeatingItems} from "@/app/events/[id]/store/buy-ticket-seating.store";

export interface AffiliateLink {
  isAffiliate?: boolean;
  ref?: string;
}

export const eventInSingleEventPage = signal<IEventV2>();
export const upcomingEventListInSingleEventPage = signal<Partial<IEventV2>[]>();
export const affiliateLink = signal<AffiliateLink>({
  isAffiliate: false,
  ref: "",
});

export const updateAffiliateLink = (data: AffiliateLink) => {
  affiliateLink.value = { ...data };
};

export const loadEventById = async (
  id: string,
  previewToken?: string,
  navigate?: Function
) => {
  const [response, error] = await getSingleEventList(id, previewToken);
  if (error) {
    navigate(getPath("event-not-found"));
    return;
  }
  eventInSingleEventPage.value = response;
  if(response.isSeatingPublished){
    loadSeatingItems();
  }
};

export const ticketPriceRange = computed(() => {
  if (eventInSingleEventPage.value) {
    const { minTicketPrice, maxTicketPrice, organization } =
      eventInSingleEventPage.value;
    if (
      !isNaN(minTicketPrice) &&
      minTicketPrice !== null &&
      !isNaN(maxTicketPrice) &&
      maxTicketPrice !== null
    ) {
      const currency = organization?.organizationCurrency;
      return `${currency} ${minTicketPrice} - ${currency} ${maxTicketPrice}`;
    }
  }
  return "Price: N/A";
});

export const gotoAnotherSingleEvent = (
  navigate: Function,
  eventId: string
): void => {
  navigate(`/events/${eventId}`);
};
